module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/tactical-training-reward-50.5fc76db9.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/tactical-training-reward-50.png
// module id = 3801
// module chunks = 11